import React, { Component, Fragment } from 'react';
import MetaTags from "react-meta-tags";
import Breadcrumb from "../layouts/Breadcrumb";
import Header from '../layouts/Headerthree';
import Footer from '../layouts/Footerthree';
import Content from '../sections/Teamdetail/Content';

class Teamdetail extends Component {
    render() {
        return (
            <Fragment>
                <MetaTags>
                    <title>Onitir | Team Detail</title>
                    <meta
                        name="description"
                        content="#"
                    />
                </MetaTags>
                <Header />
                <Breadcrumb breadcrumb={{pagename:'Team Detail'}} />
                <Content/>
                <Footer />
            </Fragment>
        );
    }
}

export default Teamdetail;